import React, { useState } from "react";
import { Card, CardBody, CardHeader, Container, Row } from "reactstrap";

const ProteccionDeDatos = () => {

  const [empresa, setEmpresa] = useState("")
  const [direccion, setDireccion] = useState("")
  const [email, setEmail] = useState("")

  React.useEffect(() => {
    document.body.classList.add("bg-default");

    const storedEmpresa = localStorage.getItem('empresa');
    const storedDireccion = localStorage.getItem('direccion');
    const storedEmail = localStorage.getItem('email');

    localStorage.clear()

    
    
    if (storedEmpresa) {
      setEmpresa(JSON.parse(storedEmpresa));
    }
    if (storedDireccion) {
      setDireccion(JSON.parse(storedDireccion));
    }
    if (storedEmail) {
      setEmail(JSON.parse(storedEmail));
    }

    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);

  
  return (
    <>
      <div className="main-content">
        <div className="header bg-gradient-warning py-7 py-lg-8">
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Card>
              <CardHeader>
                <h1>Protección de datos </h1>
              </CardHeader>

              <CardBody>
                <p>
                  {empresa} es el{" "}
                  <strong>Responsable del tratamiento</strong> de los datos
                  personales del <strong>Interesado </strong>y le informa de que
                  estos datos se tratar&aacute;n de conformidad con lo dispuesto
                  en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la
                  Ley Org&aacute;nica 3/2018, de 5 de diciembre (LOPDGDD), por
                  lo que se le facilita la siguiente informaci&oacute;n del
                  tratamiento:
                </p>
                <p>
                  <strong>
                    Fines del tratamiento para la ejecuci&oacute;n del contrato
                    laboral (art. 6.1.b GDPR):
                  </strong>
                </p>
                <ul>
                  <li>
                    Mantener, desarrollar y gestionar la relaci&oacute;n
                    laboral.
                  </li>
                  <ul>
                    <li>
                      <em>
                        Cuando se traten categor&iacute;as especiales de datos:
                        por ser necesario para el cumplimiento de obligaciones y
                        el ejercicio de derechos espec&iacute;ficos del
                        responsable del tratamiento o del interesado en el
                        &aacute;mbito del Derecho laboral y de la seguridad
                        (art. 9.2.b GDPR).
                      </em>
                    </li>
                  </ul>
                  <li>
                    Control laboral a trav&eacute;s de geolocalizaci&oacute;n,
                    si procede.
                  </li>
                  <ul>
                    <li>
                      <em>
                        Normativa espec&iacute;fica: RDL 2/2015, por el que se
                        aprueba el texto refundido de la Ley del Estatuto de los
                        Trabajadores (art. 20.3) LOPDGDD 3/2018 (art. 90).
                      </em>
                    </li>
                  </ul>
                </ul>
                <p>
                  <strong>
                    Fines del tratamiento para el cumplimiento de obligaciones
                    legales del responsable (art. 6.1.c GDPR):
                  </strong>
                </p>
                <ul>
                  <li>Registro horario</li>
                  <ul>
                    <li>
                      <em>
                        Normativa espec&iacute;fica: RDL 8/2019 de medidas
                        urgentes de protecci&oacute;n social y de lucha contra
                        la precariedad laboral en la jornada de trabajo.
                      </em>
                    </li>
                    <li>
                      <em>
                        Criterios espec&iacute;ficos de conservaci&oacute;n:
                        durante 4 a&ntilde;os seg&uacute;n lo establecido en el
                        RDL 8/2019.
                      </em>
                    </li>
                  </ul>
                  <li>
                    Gesti&oacute;n irregularidades comunicadas a trav&eacute;s
                    del canal de denuncias internas, si procede.
                  </li>
                  <ul>
                    <li>
                      <em>
                        Normativa espec&iacute;fica: Ley 2/2023, reguladora de
                        la protecci&oacute;n de las personas que informen sobre
                        infracciones normativas y de lucha contra la
                        corrupci&oacute;n.
                      </em>
                    </li>
                    <li>
                      <em>
                        Reserva de su identidad: conforme al art&iacute;culo
                        31.1 de la Ley 2/2023, le informamos de que su identidad
                        ser&aacute; en todo caso reservada y que no se
                        comunicar&aacute; a las personas a las que se refieren
                        los hechos relatados ni a terceros.
                      </em>
                    </li>
                    <li>
                      <em>
                        Criterios espec&iacute;ficos de conservaci&oacute;n: un
                        plazo m&aacute;ximo de tres meses tras la
                        notificaci&oacute;n de la irregularidad si los hechos no
                        hubieran sido probados y siempre que no resulten
                        necesarios para otras finalidades o a efectos
                        probatorios del debido control y supervisi&oacute;n en
                        la prevenci&oacute;n de delitos. En caso de que los
                        hechos s&iacute; resulten probados o con indicios
                        suficientes, los datos se conservar&aacute;n en tanto
                        sea necesario para el ejercicio por parte de la entidad
                        de sus derechos ante los tribunales de justicia.
                      </em>
                    </li>
                  </ul>
                </ul>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>
                  <strong>Criterios de conservaci&oacute;n de los datos</strong>
                  : se conservar&aacute;n durante no m&aacute;s tiempo del
                  necesario para mantener el fin del tratamiento o mientras
                  existan prescripciones legales que dictaminen su custodia y
                  cuando ya no sea necesario para ello, se suprimir&aacute;n con
                  medidas de seguridad adecuadas para garantizar la
                  anonimizaci&oacute;n de los datos o la destrucci&oacute;n
                  total de los mismos.
                </p>
                <p>
                  <strong>Comunicaci&oacute;n de los datos</strong>: no se
                  comunicar&aacute;n los datos a terceros, salvo
                  obligaci&oacute;n legal y/o cuando sea necesario para la
                  relaci&oacute;n contractual.
                </p>
                <p>
                  <strong>Derechos que asisten al Interesado</strong>:<br /> -
                  Derecho de acceso, rectificaci&oacute;n, portabilidad y
                  supresi&oacute;n de sus datos, y de limitaci&oacute;n u
                  oposici&oacute;n a su tratamiento.
                  <br /> - Derecho a presentar una reclamaci&oacute;n ante la
                  Autoridad de control (www.aepd.es) si considera que el
                  tratamiento no se ajusta a la normativa vigente.
                </p>
                <p>
                  <strong>Datos de contacto para ejercer sus derechos:</strong>
                </p>
                <p>{empresa}</p>
                <p>{direccion}</p>
                <p>{email}</p>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ProteccionDeDatos;
